import { useState, useEffect } from "react"
import { useUpdateLessonMutation, useDeleteLessonMutation } from "./lessonsApiSlice"
import { useNavigate, useParams } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight, faSave, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import TimeLeft from "../../partial/TimeLeft"

const EditLessonForm = ({ lesson, groups:groupsProps }) => {
    const {groupId, type} = useParams()
    const [updateLesson, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useUpdateLessonMutation()

    const [deleteLesson, {
        isSuccess: isDelSuccess,
        isError: isDelError,
        error: delerror
    }] = useDeleteLessonMutation()

    const navigate = useNavigate()
    const [title, setTitle] = useState(lesson.title)
    const [group, setGroup] = useState(lesson.group)

    const [dt, setDt] = useState(new Date(lesson.dt))
    const [fromDate, setFromDate] = useState(new Date(lesson.fromDate))
    const [toDate, setToDate] =useState(new Date(lesson.toDate))
    const [active, setActive] = useState(lesson.active)
    const [numberOfLessons, setNumberOfLessons] = useState(lesson.numberOfLessons || 3)




    useEffect(() => {
        if (isSuccess || isDelSuccess) {
            setTitle('')
            navigate(`/${type}/${groupId}/lessons`)
        }

    }, [isSuccess, isDelSuccess, navigate])

    



    const onSaveLessonClicked = async (e) => {

            await updateLesson({ id:lesson.id, title, group, dt, fromDate, toDate,  active ,numberOfLessons })
     
    }

    const onDeleteLessonClicked = async () => {
        await deleteLesson({ id: lesson.id })
    }

    const groupsOptions = groupsProps.map(group => {
        return (
            <option
                key={group.id}
                value={group.id}
            > {group.name}</option >
        )
    })

    const canSave = [title, group, dt, fromDate, toDate].every(Boolean) && !isLoading


    const errClass = (isError || isDelError) ? "errmsg" : "offscreen"
   
    const errContent = (error?.data?.message || delerror?.data?.message) ?? ''

//setActive(prev => !prev)
    const content = (
        <>
            <p className={errClass}>{errContent}</p>

            <form className="form" onSubmit={e => e.preventDefault()}>
                <div className="form__title-row">
                    <h2>Edit Lesson</h2>
                    <div className="form__action-buttons">
                    <button
                            className="icon-button"
                            title="Back"
                            onClick={()=>{navigate(`/${type}/${groupId}/lessons`)}}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>
                        <button
                            className="icon-button"
                            title="Save"
                            onClick={onSaveLessonClicked}
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                        <button
                            className="icon-button"
                            title="Delete"
                            onClick={onDeleteLessonClicked}
                        >
                            <FontAwesomeIcon icon={faTrashCan} />
                        </button>
                    </div>
                </div>
                <label className="form__label" htmlFor="title">
                title: </label>

  <div className="flex gap-2">
                 <input
                   className={`form__input flex-1  ${!title &&'form__input--incomplete'}`}
                    id="title"
                    name="title"
                    type="text"
                    autoComplete="off"
                    value={title}
                    onChange={(e)=>setTitle(e.target.value)}
                />
                 <input
                 placeholder="Number of Lessons"
                 title="Number of Lessons"
                   className={`form__input  w-60 `}
                    id="numberOfLessons"
                    name="numberOfLessons"
                    type="Number"
                    autoComplete="off"
                    value={numberOfLessons}
                    onChange={(e)=>setNumberOfLessons(e.target.value)}
                />
                </div>

               
                 <label className="form__label" htmlFor="group">
        group:</label>
        <select
                        id="group"
                        name="group"
                        className={`form__input  ${!group &&'form__input--incomplete'}`}
                        value={group}
                        readOnly
                        disabled
                        onChange={(e)=>setGroup(e.target.value)}
                    >
                        <option></option>
                        {groupsOptions}
                    </select>

                    <label className="form__label" htmlFor="dt">
                    Date:</label>
                <input
                    className={`form__input  ${!dt &&'form__input--incomplete'}`}
                    id="dt"
                    name="dt"
                    type="datetime-local"
                    autoComplete="off"
                    value= {`${dt.getFullYear().toString()}-${(dt.getMonth() + 1).toString().padStart(2, 0)}-${dt.getDate().toString().padStart(2, 0)}T${dt.getHours().toString().padStart(2, 0)}:${dt.getMinutes().toString().padStart(2, 0)}`}
                    onChange={(e)=>setDt(new Date(e.target.value))}
                />

                    <div className="form-flex">

<div className="form-input-container">
                 <label className="form__label" htmlFor="fromDatedt">
                    From Date:</label>
                <input
                    className={`form__input  ${!fromDate &&'form__input--incomplete'}`}
                    id="fromDate"
                    name="fromDate"
                    type="datetime-local"
                    autoComplete="off"
                    value= {`${fromDate.getFullYear().toString()}-${(fromDate.getMonth() + 1).toString().padStart(2, 0)}-${fromDate.getDate().toString().padStart(2, 0)}T${fromDate.getHours().toString().padStart(2, 0)}:${fromDate.getMinutes().toString().padStart(2, 0)}`}
                    onChange={(e)=>setFromDate(new Date(e.target.value))}
                />
                </div>
                <div className="form-input-container">

                <label className="form__label form__title-row" htmlFor="toDate">
                   <span> To Date:</span> <small > (<TimeLeft endtime={toDate} />)</small> </label>
                <input
                    className={`form__input  ${!toDate &&'form__input--incomplete'}`}
                    id="toDate"
                    name="toDate"
                    type="datetime-local"
                    autoComplete="off"
                    value= {`${toDate.getFullYear().toString()}-${(toDate.getMonth() + 1).toString().padStart(2, 0)}-${toDate.getDate().toString().padStart(2, 0)}T${toDate.getHours().toString().padStart(2, 0)}:${toDate.getMinutes().toString().padStart(2, 0)}`}
                    onChange={(e)=>setToDate(new Date(e.target.value))}
                />
                </div>
                </div>

                    <label className="form__label form__checkbox-container" htmlFor="user-active">
                    ACTIVE:
                    <input
                        className="form__checkbox"
                        id="user-active"
                        name="user-active"
                        type="checkbox"
                        checked={active}
                        onChange={(e)=>setActive(prev => !prev)}
                    />
                </label>

              


               
              

            </form>
        </>
    )

    return content
}
export default EditLessonForm